import { API_URL } from 'config';
import configureAPI from './shared/apiFactory';

const api = configureAPI(API_URL);

export default api;
